// extracted by mini-css-extract-plugin
export default {"focus":"bijBg2FMyyifMdpCfvKP","secondLabel":"S9yXs_DvArAWngXvM1zi","checked":"mIkLRY8jefwaH7mAXB_h"};